/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetClientsRequestDto } from '../../models/get-clients-request-dto';
import { GetClientsResponseDto } from '../../models/get-clients-response-dto';

export interface ClientGetAllClientsDataPost$Params {
      body?: GetClientsRequestDto
}

export function clientGetAllClientsDataPost(http: HttpClient, rootUrl: string, params?: ClientGetAllClientsDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GetClientsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientGetAllClientsDataPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GetClientsResponseDto>>;
    })
  );
}

clientGetAllClientsDataPost.PATH = '/Client/GetAllClientsData';
